import { Conta } from './conta';
import { Cedente } from './cedente';
import { Sacado } from './sacado';
import { BoletoValor } from './boletoValor';
import { Identificacao } from './identificacao';

export class Boleto {
  nuTransacao: string;
  nuProtocolo: string;
  cdRetorno: string;
  cdMsgemRetorno: string;
  dsMsgemRetorno: string;
  dsMsgemMainframeRetorno: string;
  nuControle: string;
  nuDocumento: string;
  cdCtrlProcessamento: string;
  textoAutenticacao: string;
  cdIndcdTransacao: string;
  lstMensagem: Array<string>;
  nuBoleto: string;
  dtVencimento: string;
  dtPagamento: string;
  dtEmissao: string;
  dtProcessamento: string;
  dsTitulo: string;
  cdLiberacaoCredito: string;
  nuCartelaInstrucaoPermanente: string;
  cdCarteira: string;
  cdIndicadorMoeda: string;
  cdTipoTitulo: string;
  cdProduto: string;
  cdEspecie: string;
  cdAceite: string;
  cdMoeda: string;
  tpPapeleta: string;
  qtQuantidade: string;
  urlBoleto: string;
  conta: Conta;
  cedente: Cedente;
  sacado: Sacado;
  boletoValor: BoletoValor;
  identificacao: Identificacao;
  listaInstrucoes: Array<string>;
  listaInstrucoesFixas: Array<string>;
  arquivoPdf: string;
  cardif: string;
  constructor() {
  }
}

export class LiquidacaoContratoRequest {
  nuCTRL: string;
  nuContrato: string;
  vrTotalSaldoDevedor: string;
  constructor() {
  }
}

export class LiquidacaoParcelaRequest {
  nuCTRL: string;
  nuContrato: string;
  qtParcelasAbertas: string;
  cdOrdemParcelasAbertas: string;
  vrTotalMulta: string;
  vrTotalMora: string;
  vrTotalDesconto: string;
  vrTotalAtualizado: string;
  vrTotalEncargosRemu: string;
  vrTotalEncargosMora: string;
  nuCalculo: string;
  constructor() {
  }
}
 export class BoletoHibrido{
  cardif: string;
  cdMsgemRetorno: string;
  dsMsgemRetorno: string;
  cdProdutoBradesco: number;
  cdFamiliaContrato: number;
  cdContrato: number;
  cdSequenciaAtualizacaoContrato: number;
  cdIdentificadorParcela: string;
  cdSituacaoPagto: string;
  nuContrato: number;
  dtVencimentoTitulo: string;
  vrBoletoMoedaVigente: number;
  dsBaseCaracter: string;
  arquivoPdf: string;
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/boleto.ts